export type LeagueFormat = 'managed';

// How matchups & standings are determined
export type LeagueType = 'h2h-points' | 'h2h-cats' | 'roto';

// Whether lineups lock weekly or daily
export type ScoringFormat = 'weekly' | 'daily';

// For category leagues: how categories are defined
export type CategoryStyle = 'grouped' | 'individual' | 'custom';

export interface CategoryConfig {
  style: CategoryStyle;
  // For 'grouped': uses scoring rule categories (Passing, Rushing, etc.)
  // For 'individual': specific stats act as categories
  customCategories?: string[]; // stat IDs chosen as categories
  winsPerCategory: boolean; // H2H cats: does each category count as a win?
  // SAB-903: 'none' removed -- seeding must always be determined, and nothing could
  // honour an option meaning "leave ties unresolved". Legacy rows holding it fall
  // back to total points at read time.
  tiebreaker: 'total-points' | 'head-to-head';
}

export interface LeagueSettings {
  name: string;
  teamCount: 8 | 10 | 12 | 14 | 16;
  leagueFormat: LeagueFormat;
  leagueType: LeagueType;
  scoringFormat: ScoringFormat;
  scoringType: 'trash' | 'standard' | 'ppr';
  categoryConfig?: CategoryConfig;
  draftType: 'snake' | 'linear' | 'auction' | 'slow';
  waiverType: 'free_agent' | 'faab_nightly' | 'faab_sunday';
  faabBudget: number;
  tradeDeadline: Date | null;
  playoffTeams: 4 | 6 | 8;
  playoffStartWeek: number;
  regularSeasonWeeks: number;
}

export interface LeagueInvite {
  id: string;
  leagueId: string;
  leagueName: string;
  invitedBy: string;
  inviteCode: string;
  status: 'pending' | 'accepted' | 'declined' | 'expired';
  expiresAt: Date;
  createdAt: Date;
  teamCount: number;
  filledSpots: number;
  scoringType: string;
}

export interface CreateLeagueStep {
  id: string;
  title: string;
  description: string;
  isComplete: boolean;
}

export const DEFAULT_LEAGUE_SETTINGS: LeagueSettings = {
  name: '',
  teamCount: 10,
  leagueFormat: 'managed',
  leagueType: 'h2h-points',
  scoringFormat: 'weekly',
  scoringType: 'trash',
  draftType: 'snake',
  waiverType: 'faab_nightly',
  faabBudget: 100,
  tradeDeadline: null,
  playoffTeams: 4,
  playoffStartWeek: 14,
  regularSeasonWeeks: 13,
};

export const DEFAULT_CATEGORY_CONFIG: CategoryConfig = {
  style: 'grouped',
  winsPerCategory: true,
  tiebreaker: 'total-points',
};
